<!-- Header Area -->
<header class="header-area">
  <!-- <div class="top-header">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-lg-6 col-sm-6">
                    <ul class="left-info">
                        <li><a href="mailto:info@vconfiger.com"><i class='bx bxs-envelope'></i> info@vconfiger.com</a></li>
                        <li><a href="tel:+17326924748"><i class='bx bxs-phone'></i> +1 (732) 692- 4748</a></li>
                        <li><a href="tel:+919949944327"><i class='bx bxs-phone'></i>+91 994 994 4327</a></li>

                    </ul>
                </div>

                <div class="col-lg-6 col-sm-6">
                    <ul class="right-info">
                        <li class="mr-20"><a routerLink="/contact">Contact</a></li>
                        <li class="mr-20"><a routerLink="/Careers">Careers</a></li>
                    </ul>
                </div>
            </div>
        </div>
    </div> -->

  <div class="navbar-area">
    <div class="floza-responsive-nav">
      <div class="container">
        <div class="floza-responsive-menu">
          <div class="logo_brand" style="padding-top: 18px;">Dr. Asfar Ahamed

            <!-- <a routerLink="/"><img style="height:86px;" src="../../../../assets/img/vconfiger logo.jpg" alt="logo"></a> -->
          </div>
        </div>
      </div>
    </div>

    <div class="floza-nav">
      <div class="container">
        <nav class="navbar navbar-expand-md navbar-light">
          <a class="navbar-brand" routerLink="/">
            <div class="logo_brand" style="padding-top: 25px;">Dr. Asfar Ahamed</div>
            <!-- <img style="height: 70px;" src="../../../../assets/img/vconfiger logo.jpg" alt="logo"> -->
          </a>
          <div class="collapse navbar-collapse mean-menu">
            <ul class="navbar-nav ml-auto">
              <li class="nav-item"><a routerLink="/" class="nav-link" routerLinkActive="active"
                  [routerLinkActiveOptions]="{exact: true}">Home</a></li>

              <li class="nav-item"><a routerLink="/about" class="nav-link" routerLinkActive="active"
                  [routerLinkActiveOptions]="{exact: true}">About us</a></li>

              <li class="nav-item">
                <a href="javascript:void(0)" routerLink="/services" class="nav-link">Our Treatments
                  <i class='bx bx-chevron-down'></i>
                </a>
                <ul class="dropdown-menu">
                  <li class="nav-item" *ngFor="let services of services"><a
                          routerLink="/treatments/{{services.servicesUrl}}" class="nav-link"
                          routerLinkActive="active"
                          [routerLinkActiveOptions]="{exact: true}">{{services.navbartext}}</a></li>
              </ul>

                <!-- <ul class="dropdown-menu">
                  <li class="nav-item">
                    <a href="javascript:void(0)" class="nav-link" routerLink="/IT-Services/IT-Services">IT Services
                      <i class='bx bx-chevron-down'></i>
                    </a>
                    <ul class="dropdown-menu">
                      <li class="nav-item">
                        <a [routerLink]="['/IT-Services/CRM-Implementation']" class="nav-link" routerLinkActive="active"
                          [routerLinkActiveOptions]="{exact: true}"> CRM-Implementation</a>
                      </li>
                      <li class="nav-item">
                        <a [routerLink]="['/IT-Services/Business-Intelligence']" class="nav-link"
                          routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"> Business Intelligence</a>
                      </li>
                      <li class="nav-item">
                        <a [routerLink]="['/IT-Services/Artificial-Intelligence']" class="nav-link"
                          routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">Artificial
                          Intelligence</a>
                      </li>
                      <li class="nav-item">
                        <a [routerLink]="['/IT-Services/Machine-Learning-&-Deep-Learning-Integrations']"
                          class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"> ML & DL
                          Integrations</a>
                      </li>
                    </ul>
                  </li>
                  <li class="nav-item">
                    <a href="javascript:void(0)" class="nav-link">Clinical Data
                      <i class='bx bx-chevron-down'></i>
                    </a>


                    <ul class="dropdown-menu">
                      <li class="nav-item">
                        <a [routerLink]="['/Clinical-Data/Statistical-Programming']" class="nav-link"
                          routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"> Statistical
                          Programming</a>
                      </li>
                      <li class="nav-item">
                        <a [routerLink]="['/Clinical-Data/Bio-Statistics']" class="nav-link" routerLinkActive="active"
                          [routerLinkActiveOptions]="{exact: true}">Bio Statistics</a>
                      </li>
                      <li class="nav-item">
                        <a [routerLink]="['/Clinical-Data/Clinical-Data-Management']" class="nav-link"
                          routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"> Clinical Data
                          Management</a>
                      </li>
                      <li class="nav-item">
                        <a [routerLink]="['/Clinical-Data/Clinical-Data-Integration']" class="nav-link"
                          routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"> Clinical Data
                          Integration</a>
                      </li>
                      <li class="nav-item">
                        <a [routerLink]="['/Clinical-Data/Performance-Metrics-Development']" class="nav-link"
                          routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"> Clinical Trail
                          Performance Metrics</a>
                      </li>
                    </ul>
                  </li>
                  <li class="nav-item">
                    <a href="javascript:void(0)" class="nav-link">Education
                      <i class='bx bx-chevron-down'></i>
                    </a>
                    <ul class="dropdown-menu">
                      <li class="nav-item">
                        <a [routerLink]="['/Education/Chanakya-Degree-&-PG-College']" class="nav-link"
                          routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">Chanakya Degree & Pg
                          College</a>
                      </li>
                      <li class="nav-item">
                        <a [routerLink]="['/Education/Chanakya-Reading-Room']" class="nav-link"
                          routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">Chanakya Reading Room</a>
                      </li>
                    </ul>
                  </li>  <li class="nav-item">
                    <a href="javascript:void(0)" class="nav-link">Training
                      <i class='bx bx-chevron-down'></i>
                    </a>
                    <ul class="dropdown-menu">
                      <li class="nav-item">
                        <a [routerLink]="['/Training/SAS-Training']" class="nav-link" routerLinkActive="active"
                          [routerLinkActiveOptions]="{exact: true}">SAS Training</a>
                      </li>
                      <li class="nav-item">
                        <a [routerLink]="['/Training/Statistics-Training']" class="nav-link" routerLinkActive="active"
                          [routerLinkActiveOptions]="{exact: true}">Statistics Training</a>
                      </li>
                      <li class="nav-item">
                        <a [routerLink]="['/Training/Salesforce']" class="nav-link" routerLinkActive="active"
                          [routerLinkActiveOptions]="{exact: true}">Salesforce</a>
                      </li>
                    </ul>
                  </li>

                </ul> -->
              </li>
              <li class="nav-item"><a routerLink="/gallery" class="nav-link" routerLinkActive="active"
                [routerLinkActiveOptions]="{exact: true}">Gallery</a></li>
            <li class="nav-item"><a routerLink="/blog" class="nav-link" routerLinkActive="active"
                  [routerLinkActiveOptions]="{exact: true}">Blog</a></li>
             

              <!-- <li class="nav-item"><a routerLink="/Jobs" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}">Tech Support</a></li> -->


              <li class="nav-item"><a routerLink="/contact" class="nav-link" routerLinkActive="active"
                  [routerLinkActiveOptions]="{exact: true}">Contact us</a></li>

              <li class="nav-item"><a routerLink="/sign-in" class="nav-link" routerLinkActive="active"
                  [routerLinkActiveOptions]="{exact: true}">Login</a></li>                  

            </ul>
          </div>
        </nav>
      </div>
    </div>
  </div>
</header>
<!-- End Header Area -->